/**
 * Element fullscreen, where the platform has it.
 *
 * Used by the image viewer (core/Gallery): opened by a tap, it takes the whole
 * screen — on a phone in the browser that hides the address bar, on a desktop
 * it leaves the phone-shaped frame. iPhone Safari has no element fullscreen
 * (only for video); there these calls do nothing and the viewer stays the
 * in-app overlay it always was. Never called without a user gesture, never on
 * its own.
 */
export const Fullscreen = {
    isSupported()
    {
        const el = document.documentElement;
        return !!( el.requestFullscreen || el.webkitRequestFullscreen ) &&
            ( document.fullscreenEnabled !== false && document.webkitFullscreenEnabled !== false );
    },

    isActive()
    {
        return !!( document.fullscreenElement || document.webkitFullscreenElement );
    },

    async enter( element )
    {
        if ( !Fullscreen.isSupported() || Fullscreen.isActive() )
        {
            return false;
        }
        try
        {
            if ( element.requestFullscreen )
            {
                await element.requestFullscreen( { navigationUI : "hide" } );
            }
            else
            {
                element.webkitRequestFullscreen();
            }
            return true;
        }
        catch ( e )
        {
            return false;
        }
    },

    async exit()
    {
        if ( !Fullscreen.isActive() )
        {
            return;
        }
        try
        {
            if ( document.exitFullscreen )
            {
                await document.exitFullscreen();
            }
            else if ( document.webkitExitFullscreen )
            {
                document.webkitExitFullscreen();
            }
        }
        catch ( e )
        {
            // Already left (Escape, back gesture) — nothing to do.
        }
    }
};
